import { render, staticRenderFns } from "./KEmptyPlaceholder.vue?vue&type=template&id=1903cba6&scoped=true&"
import script from "./KEmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./KEmptyPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./KEmptyPlaceholder.vue?vue&type=style&index=0&id=1903cba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1903cba6",
  null
  
)

component.options.__file = "KEmptyPlaceholder.vue"
export default component.exports